import React, {useEffect,useRef, useState} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image, Grid, Collapse, Modal} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchCardsListAction, fetchInfographicsByCodeAction, fetchPsychoCardsListAction, fetchSensoryVideoListAction, ROUTE_PATH, selectStore} from "../../../utils";
import {MySegmented,MyText} from "../../../components";
import {CaretRightOutlined, LeftOutlined, ForwardOutlined, PauseOutlined } from "@ant-design/icons";
import { MyButton } from "../../../components";
import Image1 from '../../../assets/images/pages/Main/psycho-support-current.webp'
import ImageCholeric from '../../../assets/images/pages/Main/choleric.svg'
import ImageMelancholic from '../../../assets/images/pages/Main/melancholic.svg'
import ImageSanguine from '../../../assets/images/pages/Main/sanguine.svg'
import ImagePhlegmatic from '../../../assets/images/pages/Main/phlegmatic.svg'
import { COOKIE_KEY } from "../../../utils";
import { PageName, ButtonContainer, ThemeCollapse, StyledImageWrapper } from "../style";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../../utils/context/embed";
import { Helmet } from "react-helmet";
import { Cookies } from "react-cookie";
import { useLang } from "../../../utils/context/lang";

export const CurrentPsychoPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const { lang } = useLang();
  const {t} = useTranslation("common")
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const age = searchParams.get("age");
  // const {gameCategory} = useParams();
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }
  const isMobile = screens.xs;
  const { Panel } = Collapse;
const { type, supportId } = useParams<{ type: any; supportId: any }>();
    const {materials: {talesList: talesListState}} = useSelector(selectStore)
    const sensoryVideoList = useSelector((state: any) => state.materials?.sensoryVideoList ?? { data: null, loading: false });

  const cookies = new Cookies()
  const topicIdFromParams = searchParams.get('topic_id');
  const segmentedParams: any = searchParams.get('type');
  const [authors, setAuthors] = useState([]);
  const [articles, setArticles] = useState([]);
  const initialTopicId = topicIdFromParams ? Number(topicIdFromParams) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState<number | null>(initialTopicId);
  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  const [selectedParentTheme, setSelectedParentTheme] = useState<any>(null);
  const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [localLikes, setLocalLikes] = useState<Record<number, boolean>>({});
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const infographicsByCode = useSelector((state: any) => state.materials?.infographicsByCode ?? { data: null, loading: false });
  const psychoCardsList = useSelector((state: any) => state.articles?.psychoCardsList ?? { data: [], loading: false });

const [player, setPlayer] = useState<any>(null);
const playerRef = useRef<HTMLDivElement | null>(null);
  const [duration, setDuration] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [multimedia, setMultimedia] = useState<any[]>([]);
  const [playlists, setPlaylists] = useState<any[]>([]);

  const [themes, setThemes] = useState([]);
  const [infographic, setInfographic] = useState([]);
  const [infographicByCode, setInfographicByCode] = useState<any[]>([]);

  const [isThemesModalVisible, setIsThemesModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalImage, setModalImage] = useState("");
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const isTablet = screens.md && !screens.xl && !screens.xxl;


  const handleOpenModal = (imagePath: string) => {
    setModalImage(imagePath);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalImage("");
  };

 const PLAY_ITEMS = [
  { id: 'sensory', text: t("sensory") },
  { id: 'familyPsychology', text: t("familyPsychology") },
  { id: 'developing', text: t("developing") },
  { id: 'neurogym', text: t("neurogym") },
  { id: 'art', text: t("art") },
  { id: 'fairytale', text: t("fairytale") },
  { id: 'speech', text: t("speech") },
];

const RECOMMEND_ITEMS = [
  { id: 'mental', text: t("mental") },
  { id: 'school', text: t("school") },
  { id: 'adaptation', text: t("adaptation") },
  { id: 'features', text: t("features")},
  { id: 'support', text: t("support")},
];

  const currentItem =
    PLAY_ITEMS.find(item => item.id === supportId) ||
    RECOMMEND_ITEMS.find(item => item.id === supportId);

    const currentTitle = currentItem ? currentItem.text : "Психолого-педагогическая поддержка";

  const handlePanelChange = (key) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };  

    const temperamentDetails = {
    1: {
      desc: t("temperament_choleric_desc"),
      image: ImageCholeric,
    },
    2: {
      desc: t("temperament_melancholic_desc"),
      image: ImageMelancholic,
    },
    3: {
      desc: t("temperament_sanguine_desc"),
      image: ImageSanguine,
    },
    4: {
      desc: t("temperament_phlegmatic_desc"),
      image: ImagePhlegmatic,
    },
  };

  // const parentThemesButton = themes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);

//   useEffect(() => {
//   const fetchContent = async () => {
//     try {
//       const response = await fetchPsychoCardsList();

//       const updatedThemes = (response || []).map((item: any) => ({
//         ...item,
//         ...(temperamentDetails as any)[item.id],
//       }));

//       setThemes(updatedThemes);
//     } catch (error) {
//       console.error('Error fetching themes:', error);
//     }
//   };

//   fetchContent();
// }, []);

useEffect(() => {
  dispatch(fetchPsychoCardsListAction({}));
}, []);

useEffect(() => {
  if (!psychoCardsList.success || !psychoCardsList.data) return;

  const updatedThemes = (psychoCardsList.data || []).map((item: any) => ({
    ...item,
    ...(temperamentDetails as any)[item.id],
  }));

  setThemes(updatedThemes);
}, [psychoCardsList.success, psychoCardsList.data]);


  useEffect(() => {
    const codeWord = supportId === 'adaptation' ? 'adaptation' : 'recommendation';
    dispatch(fetchInfographicsByCodeAction(codeWord));
  }, [supportId]);

  useEffect(() => {
    if (!infographicsByCode.success || !infographicsByCode.data) return;
    setInfographicByCode(infographicsByCode.data);
  }, [infographicsByCode.success, infographicsByCode.data]);

  useEffect(() => {
    dispatch(fetchSensoryVideoListAction(supportId));
  }, [supportId]);

  useEffect(() => {
    if (!sensoryVideoList.success || !sensoryVideoList.data) return;
    setPlaylists(sensoryVideoList.data.playlists || []);
    setMultimedia(sensoryVideoList.data.multimedia || []);
  }, [sensoryVideoList.success, sensoryVideoList.data]);

  useEffect(() => {
    setSelectedCard(null);
    setPlaying(false);
    setMultimedia([]);
  }, [supportId]);

  useEffect(() => {
  if (player && typeof player.destroy === "function") {
    try {
      player.destroy();
    } catch (err) {
      console.warn("Player destroy error:", err);
    }
  }
  setPlayer(null);
  setPlaying(false);
}, [supportId]);

  const {materials: {cardsList: cardsListState}} = useSelector(selectStore)

  const isLikedForList = (card: any) =>
  card.id in localLikes ? localLikes[card.id] : !!card.is_liked;

  const getBaseIsLiked = (cardId: number) => {
    const cardFromList = talesListState?.data?.cards?.find((c: any) => c.id === cardId);
    if (cardFromList) return !!cardFromList.is_liked;
    if (selectedCard?.id === cardId) return !!selectedCard.is_liked;
    return false;
  };

  const togglePlay = () => {
  if (!player) return;

  if (playing) {
    player.pauseVideo();
    setPlaying(false);
  } else {
    player.playVideo();
    setPlaying(true);
  }
};

  // const toggleLike = (cardId: number) => {
  //   const base = getBaseIsLiked(cardId);
  //   const current = cardId in localLikes ? localLikes[cardId] : base;
  //   const newVal = !current;
  
  //   setLocalLikes((prev) => ({ ...prev, [cardId]: newVal }));
  //   if (selectedCard?.id === cardId) {
  //     setSelectedCard((prev) => (prev ? { ...prev, is_liked: newVal } : prev));
  //   }    
  
  //   fetchSetLike(cardId, "cards")
  //     .then((res) => {
  //       const serverVal = res?.data?.is_liked;
  //       if (typeof serverVal === "boolean") {
  //         setLocalLikes((prev) => ({ ...prev, [cardId]: serverVal }));
  //         if (selectedCard?.id === cardId) {
  //           setSelectedCard((prev) => (prev ? { ...prev, is_liked: serverVal } : prev));
  //         }
  //       }
  //     })
  //     .catch(() => {
  //       setLocalLikes((prev) => {
  //         const copy = { ...prev };
  //         copy[cardId] = base;
  //         return copy;
  //       });
  //       if (selectedCard?.id === cardId) {
  //         setSelectedCard((prev) => (prev ? { ...prev, is_liked: base } : prev));
  //       }
  //     });
  // };

  useEffect(() => {
    
      dispatch(fetchCardsListAction({
        // category: gameCategory,
        // fromAge,
        // toAge
      }))
    
  }, [])

  useEffect(() => {
  const topicIdFromParams = searchParams.get('topic_id');

  if (!topicIdFromParams) {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
    return;
  }

  const topicId = Number(topicIdFromParams);
  const matchedTheme = themes.find(theme => theme.id === topicId);

  if (matchedTheme) {
    setSelectedSubThemeId(topicId);
    setSelectedSubThemeName(matchedTheme.name);
    setSelectedParentTheme(matchedTheme);
  } else {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
  }
}, [themes, searchParams, t]);


  const handleSelectCard = (id: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.CURRENT_PSYCHO_DETAIL, { type: type, supportId: supportId, categoryId: id}),

    }

    embeddedNavigate(path)
  }

    const handleChangeSegmented = (value: any) => {
    const existingParams = Object.fromEntries(searchParams.entries());

    const newParams: Record<string, string> = {
        ...existingParams,
        type: value,
    };

    if (selectedSubThemeId !== null) {
        newParams.topic_id = selectedSubThemeId;
    } else {
        delete newParams.topic_id;
    }

    setSearchParams(newParams);
    setSearchTerm('');
    };

  const handleGoBack = () => {
    embeddedNavigate(`/psycho-ped-support?type=${type}`);
  }

  const handleCardClick = (e: React.MouseEvent<HTMLDivElement>) => {
      const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const ratio = Math.max(0, Math.min(1, clickX / rect.width));
      const newProgress = ratio * 100;
      setProgress(newProgress);
    
      const audio = audioRef.current;
      const dur = (audio && audio.duration && !isNaN(audio.duration)) ? audio.duration : duration;
      if (audio && dur && !isNaN(dur) && dur > 0) {
        audio.currentTime = dur * ratio; 
      }
    };

  useEffect(() => {
    if (multimedia?.length && !selectedCard) {
      setSelectedCard(multimedia[0]);
    }
  }, [multimedia]);

 

  const parentThemesButton = themes;
  const videoId = selectedCard
      ? new URL(selectedCard.link).searchParams.get("v")
      : null;

useEffect(() => {
  if (!videoId) return;

  let isUnmounted = false;
  let localPlayer = player;

  const loadPlayer = () => {
    if (isUnmounted || !playerRef.current) return;

    if (localPlayer) {
      try {
        localPlayer.loadVideoById(videoId);
        localPlayer.playVideo();
        setPlaying(true);
      } catch {
        createPlayer();
      }
      return;
    }

    createPlayer();
  };

  const createPlayer = () => {
    if (!playerRef.current) return;

    // @ts-ignore
    const newPlayer = new window.YT.Player(playerRef.current, {
      videoId,
      events: {
        onReady: () => {
          if (isUnmounted) return;
          setPlayer(newPlayer);
          newPlayer.playVideo();
          setPlaying(true);
        },
        onStateChange: (event) => {
          if (isUnmounted) return;
          if (event.data === window.YT.PlayerState.PLAYING) setPlaying(true);
          if (
            event.data === window.YT.PlayerState.PAUSED ||
            event.data === window.YT.PlayerState.ENDED
          )
            setPlaying(false);
        },
      },
    });

    localPlayer = newPlayer;
  };
  
  const YOUTUBE_API_SRC: string = "https://www.youtube.com/iframe_api";

  const createYouTubeScript = () => {
    const tag = document.createElement("script");
    tag.src = YOUTUBE_API_SRC;
    tag.async = true;
    document.body.appendChild(tag);
  };

  // @ts-ignore
  if (window.YT && window.YT.Player) {
    loadPlayer();
  } else {
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      createYouTubeScript();
    }

    // @ts-ignore
    window.onYouTubeIframeAPIReady = () => {
      if (!isUnmounted) loadPlayer();
    };
  }

  return () => {
    isUnmounted = true;
    try {
      if (localPlayer && typeof localPlayer.destroy === "function") {
        localPlayer.destroy();
      }
    } catch (err) {
      console.warn("Player destroy error:", err);
    }
  };
}, [videoId]);

  const extractFirstImage = (html: string) => {
    if (!html) return null;

    const match = html.match(/<img[^>]+src="([^">]+)"/i);
    return match ? match[1] : null;
  };

  const imgSrc = extractFirstImage(infographicByCode?.data?.content);

  return (
    <>
          <Helmet>
            <title>Познавательные детские карточки</title>
            <meta name="description" content="Познавательные видео для обучения детей: речь, внимание, окружающий мир. Весёлые и полезные материалы для изучения дома и в детском саду." />
          </Helmet>


      <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 30}}>
           {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {t("psychoPedSupport")}
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                </ButtonContainer>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={32}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                >
                  {currentTitle}
                </MyText>
              </>
            )}
        </Row>
        {supportId === 'features' ? (
            <>
        <Row gutter={[32,32]}>

        <Col span={24}>
        
        <Card style={{borderRadius: '20px'}}>
          <Spin spinning={cardsListState?.loading}>

            <Row gutter={[40, 32]} justify={'space-between'}> 
            <Col span={(screens.xs || isTablet) ? 24 : 13}>
            <Row gutter={[24, 24]}>
                        <Col>
                        <MyText
                            color="rgba(19, 15, 38, 1)"
                            size={32}
                            weight={800}
                            style={{ fontFamily: 'Nunito', display: 'block' }}
                            >
                            {infographicByCode?.data?.title}
                        </MyText>
                        </Col>

                        <Col>
                          <div
                            style={{
                              color: "rgba(89, 89, 90, 1)",
                              fontSize: (screens.xs || isTablet) ? 16 : 18,
                              fontWeight: 400,
                              fontFamily: "Nunito",
                              lineHeight: (screens.xs || isTablet) ? "26px" : "32px",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: (infographicByCode?.data?.content || "")
                                .replace(/<div[^>]*>\s*<img[^>]*>\s*<\/div>/gi, "")
                                .replace(/<img[^>]*>/gi, "")
                            }}
                          />
                        </Col>
                    </Row>
                    </Col>

                    <Col span={(screens.xs || isTablet) ? 24 : 9}>
                    <Image
                        preview={false}
                        src={imgSrc}
                    />
                    </Col>
                    </Row>
                </Spin>
                </Card>
                </Col>
                          </Row>

                          <Row gutter={[32, 32]} style={{ marginTop: 30 }}>
                        {infographicByCode?.data?.categories?.map((item) => (
                          <Col key={item.id} span={(screens.xs || isTablet) ? 24 : 6}>
                            <Card style={{ borderRadius: '20px' }}>
                              <StyledImageWrapper style={{ height: screens.xxl ? 260 : 215 }}>
                                <Image
                                  preview={false}
                                  src={item.image}
                                  style={{ width: '100%' }}
                                />
                              </StyledImageWrapper>

                              <MyText
                                color="rgba(10, 3, 60, 1)"
                                size={24}
                                weight={700}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 24 }}
                              >
                                {item.title}
                              </MyText>

                              <MyText
                                color="rgba(104, 114, 125, 1)"
                                size={16}
                                weight={500}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 8, lineHeight: '24px', height: 72 }}
                              >
                                {item.description}
                              </MyText>

                              <MyButton 
                                onClick={() => handleOpenModal(item.subcategories?.[0]?.image_path)}
                                color="orange" 
                                type="primary" 
                                style={{ marginTop: (screens.xs || isTablet) ? 14 : 24 }}
                              >
                                {t('moreDetails')}
                              </MyButton>
                            </Card>
                          </Col>
                        ))}
                      </Row>

                      <Modal
                        visible={isModalVisible}
                        footer={null}
                        onCancel={handleCloseModal}
                        centered
                      >
                        <Image preview={false} src={modalImage} style={{ width: '100%' }} />
                      </Modal>
                        </>

        ) : supportId === 'support' ? (
          <>
        <Row gutter={[32,32]}>

        <Col span={24}>
        
        <Card style={{borderRadius: '20px'}}>
          <Spin spinning={cardsListState?.loading}>

            <Row gutter={[40, 32]} justify={'space-between'}> 
            <Col span={(screens.xs || isTablet) ? 24 : 13}>
            <Row gutter={[24, 24]}>
                        <Col>
                        <MyText
                            color="rgba(19, 15, 38, 1)"
                            size={32}
                            weight={800}
                            style={{ fontFamily: 'Nunito', display: 'block' }}
                            >
                            {t("temperament_title")}
                        </MyText>
                        </Col>

                        <Col>
                            <MyText
                            color="rgba(89, 89, 90, 1)"
                            size={(screens.xs || isTablet) ? 16 : 18}
                            weight={400}
                            style={{ fontFamily: 'Nunito', display: 'block', lineHeight: (screens.xs || isTablet) ? '26px' : '32px' }}
                            >
                            {t("temperament_intro")}
                            </MyText>
                        </Col>
                        <Col>
                            <MyText
                            color="rgba(89, 89, 90, 1)"
                            size={(screens.xs || isTablet) ? 16 : 18}
                            weight={400}
                            style={{ fontFamily: 'Nunito', display: 'block', lineHeight: (screens.xs || isTablet) ? '26px' : '32px' }}
                            >
                            {t("temperament_intro_2")}
                            </MyText>
                        </Col>
                    </Row>
                    </Col>

                    <Col span={(screens.xs || isTablet) ? 24 : 9}>
                    <Image
                        preview={false}
                        src={Image1}
                    />
                    </Col>
                    </Row>
                </Spin>
                </Card>
                </Col>
                          </Row>

                          <Row gutter={[32,32]} style={{marginTop: 30}}>
                      {themes.map((item) => (
                        <Col key={item.id} span={ (screens.xs || isTablet) ? 24 : 6}>
                          <Card style={{ borderRadius: '20px' }}>
                            <StyledImageWrapper style={{height: screens.xxl ? 260 : 215}}>
                              <Image
                                preview={false}
                                src={item.image}
                                style={{ width: '100%' }}
                              />
                            </StyledImageWrapper>

                            <MyText
                              color="rgba(10, 3, 60, 1)"
                              size={24}
                              weight={700}
                              style={{ fontFamily: 'Nunito', display: 'block', marginTop: 24 }}
                            >
                              {item.name}
                            </MyText>

                            <MyText
                              color="rgba(104, 114, 125, 1)"
                              size={16}
                              weight={500}
                              style={{ fontFamily: 'Nunito', display: 'block', marginTop: 8, lineHeight: '24px', height: 72 }}
                            >
                              {item.desc}
                            </MyText>

                            <MyButton onClick={() =>  handleSelectCard(item.id)} color="orange" type="primary" style={{ marginTop: (screens.xs || isTablet) ? 14 : 24 }}>
                              {t('moreDetails')}
                            </MyButton>
                          </Card>
                        </Col>
                      ))}
                        </Row>
                        </>
        ) : supportId === 'adaptation' ? (
           <>
        <Row gutter={[32,32]}>

        <Col span={24}>
        
       <Card style={{borderRadius: '20px'}}>
  <Spin spinning={cardsListState?.loading}>
    <div style={{ overflow: 'hidden' }}>
      
      <div
        style={{
          float: (screens.xs || isTablet) ? 'none' : 'right',
          width: (screens.xs || isTablet) ? '100%' : '42%',
          marginLeft: (screens.xs || isTablet) ? 0 : 40,
          marginBottom: 16,
        }}
      >
        <Image preview={false} src={imgSrc} />
      </div>

      <MyText
        color="rgba(19, 15, 38, 1)"
        size={32}
        weight={800}
        style={{ fontFamily: 'Nunito', display: 'block', marginBottom: 24 }}
      >
        {infographicByCode?.data?.title}
      </MyText>

      <div
        style={{
          color: "rgba(89, 89, 90, 1)",
          fontSize: (screens.xs || isTablet) ? 16 : 18,
          fontWeight: 400,
          fontFamily: "Nunito",
          lineHeight: (screens.xs || isTablet) ? "26px" : "32px",
        }}
        dangerouslySetInnerHTML={{
          __html: (infographicByCode?.data?.content || "")
            .replace(/<div[^>]*>\s*<img[^>]*>\s*<\/div>/gi, "")
            .replace(/<img[^>]*>/gi, "")
        }}
      />

    </div>
  </Spin>
</Card>
                </Col>
                          </Row>

                          <Row gutter={[32, 32]} style={{ marginTop: 30 }}>
                        {infographicByCode?.data?.categories?.map((item) => (
                          <Col key={item.id} span={(screens.xs || isTablet) ? 24 : 6}>
                            <Card style={{ borderRadius: '20px' }}>
                              <StyledImageWrapper style={{ height: screens.xxl ? 260 : 215 }}>
                                <Image
                                  preview={false}
                                  src={item.image}
                                  style={{ width: '100%' }}
                                />
                              </StyledImageWrapper>

                              <MyText
                                color="rgba(10, 3, 60, 1)"
                                size={24}
                                weight={700}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 24, height: screens.xxl ? 53 : screens.xs ? 'auto' : 55 }}
                              >
                                {item.title}
                              </MyText>

                              <MyText
                                color="rgba(104, 114, 125, 1)"
                                size={16}
                                weight={500}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 8, lineHeight: '24px', height: screens.xxl ? 70 : screens.xs ? 'auto' : 112 }}
                              >
                                {item.description}
                              </MyText>

                              <MyButton 
                                onClick={() => handleOpenModal(item.subcategories?.[0]?.image_path)}
                                color="orange" 
                                type="primary" 
                                style={{ marginTop: (screens.xs || isTablet) ? 14 : 24 }}
                              >
                                {t('moreDetails')}
                              </MyButton>
                            </Card>
                          </Col>
                        ))}
                      </Row>

                      <Modal
                        visible={isModalVisible}
                        footer={null}
                        onCancel={handleCloseModal}
                        centered
                      >
                        <Image preview={false} src={modalImage} style={{ width: '100%' }} />
                      </Modal>
                        </>
         ) : supportId === 'sensory' ||
          supportId === 'familyPsychology' ||
          supportId === 'developing' ? (
          multimedia?.length ? (
            <>
            <Row gutter={[32,32]}>
                <Col span={(screens.xs || isTablet) ? 24 : 14}>
                    <Card>
                        <Row gutter={[40,40]}>
                            <Col span={24}>
                            <Row>

                                <div
  ref={playerRef}
  style={{ width: "100%", height: (screens.xs || isTablet) ? 300 : 456, borderRadius: 20, overflow: "hidden" }}
/>
                            </Row>
                            <MyText
                                color="rgba(31, 28, 20, 1)"
                                size={26}
                                weight={700}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 24 }}
                                >
                                {selectedCard?.name || "Выберите видео"}
                            </MyText>
                            </Col> 
                        </Row>
                    </Card>
                 </Col>
                 <Col
                span={(screens.xs || isTablet) ? 24 : 10}
              >
        <Card style={{borderRadius: '20px'}}>
          <Spin spinning={talesListState?.loading}>
            <Row gutter={[24, 24]}>
              {multimedia
                                .map((item) => {
                                  const videoId = new URL(item.link).searchParams.get('v');
                                  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                
                                  return (
                                    <Col
                                    key={item.id + "-game-category"}
                                    span={24}
                                    onClick={() => setSelectedCard(item)}
                                  >
                                  <Card
                                  bordered
                                  
                                  // hoverable
                                  style={{
                                    borderRadius: '24px',
                                    cursor: 'pointer',
                                    border: selectedCard?.id === item.id ? '4px solid rgb(255, 149, 0)' : "4px solid transparent",
                                  }}
                                >
                              <Row gutter={(screens.xs || isTablet) ? 12 : 16} justify="space-between" align="middle">
                                <Col
                                  span={(screens.xs || isTablet) ? 20 : 18}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: (screens.xs || isTablet) ? 12 : 24,
                                  }}
                                >
                                  <StyledImageWrapper
                                style={{
                                  height: (screens.xs || isTablet) ? 50 : 80,
                                  width: (screens.xs || isTablet) ? 50 : 80,
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  flexShrink: 0,
                                }}
                              >
                                <Image
                                  preview={false}
                                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                  src={thumbnailUrl}
                                />
                              </StyledImageWrapper>
                              <MyText
                                  color="rgba(19, 15, 38, 1)"
                                  size={(screens.xs || isTablet) ? 15 : 24}
                                  weight={800}
                                  style={{
                                    fontFamily: "Nunito",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {item.name}
                                </MyText>

                                  </Col>
                                  <Row justify="space-between" align="middle">
                          <Row
                      justify="center"
                      align="middle"
                      style={{
                        background: "rgb(255, 149, 0)",
                        borderRadius: "50%",
                        width: (screens.xs || isTablet) ? 30 : 60,
                        height: (screens.xs || isTablet) ? 30 : 60,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (selectedCard?.id === item.id) {
                          if (playing) {
                            player?.pauseVideo();
                          } else {
                            player?.playVideo();
                          }
                        } else {
                          setSelectedCard(item);
                        }
                      }}
                    >
                      {selectedCard?.id === item.id && playing ? (
                        <PauseOutlined
                          style={{
                            color: "#fff",
                            fontSize: (screens.xs || isTablet) ? 20 : 44,
                            transform: "scaleX(1.3)",
                          }}
                        />
                      ) : (
                        <CaretRightOutlined
                          style={{
                            color: "#fff",
                            fontSize: (screens.xs || isTablet) ? 30 : 44,
                            marginLeft: 5,
                            transform: "scaleX(1.3)",
                          }}
                        />
                      )}
                    </Row>
                            </Row>
                                  </Row>
                                </Card>
                                  </Col>
                                  );
                                })}
            </Row>
          </Spin>
        </Card>
        </Col>   
            </Row>
            </>
            ) : (
    <Row gutter={[32, 32]}>
      <Col span={24}>
        <Card>
          <MyText
            color="rgba(31, 28, 20, 1)"
            size={26}
            weight={700}
            style={{
              fontFamily: "Nunito",
              display: "block",
            }}
          >
            {t("newMaterialSoon")}
          </MyText>
        </Card>
      </Col>
    </Row>
  )

        ) : supportId === 'neurogym' || supportId === 'fairytale' ? (
            <>
            <Row gutter={[32,32]}>
                <Col span={(screens.xs || isTablet) ? 24 : 14}>
                    <Card>
                        <Row gutter={[40,40]}>
                            <Col span={24}>
                            <Row>

                                <div
                                  ref={playerRef}
                                  style={{ width: "100%", height: (screens.xs || isTablet) ? 300 : 456, borderRadius: 20, overflow: "hidden" }}
                                />
                            </Row>
                            <MyText
                                color="rgba(31, 28, 20, 1)"
                                size={26}
                                weight={700}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 24 }}
                                >
                                {selectedCard?.name || "Выберите видео"}
                            </MyText>
                            </Col> 
                        </Row>
                    </Card>
                 </Col>
                 <Col
                span={(screens.xs || isTablet) ? 24 : 10}
              >
        <Card style={{borderRadius: '20px'}}>
          <Spin spinning={talesListState?.loading}>
            <Row gutter={[24, 24]}>
              {multimedia
                                .map((item) => {
                                  const videoId = new URL(item.link).searchParams.get('v');
                                  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                
                                  return (
                                    <Col
                                    key={item.id + "-game-category"}
                                    span={24}
                                    onClick={() => setSelectedCard(item)}
                                  >
                                  <Card
                                  bordered
                                  
                                  // hoverable
                                  style={{
                                    borderRadius: '24px',
                                    cursor: 'pointer',
                                    border: selectedCard?.id === item.id ? '4px solid rgb(255, 149, 0)' : "4px solid transparent",
                                  }}
                                >
                              <Row gutter={(screens.xs || isTablet) ? 12 : 16} justify="space-between" align="middle">
                                <Col
                                  span={(screens.xs || isTablet) ? 20 : 18}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: (screens.xs || isTablet) ? 12 : 24,
                                  }}
                                >
                                  <StyledImageWrapper
                                style={{
                                  height: (screens.xs || isTablet) ? 50 : 80,
                                  width: (screens.xs || isTablet) ? 50 : 80,
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  flexShrink: 0,
                                }}
                              >
                                <Image
                                  preview={false}
                                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                  src={thumbnailUrl}
                                />
                              </StyledImageWrapper>
                              <MyText
                                  color="rgba(19, 15, 38, 1)"
                                  size={(screens.xs || isTablet) ? 15 : 24}
                                  weight={800}
                                  style={{
                                    fontFamily: "Nunito",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {item.name}
                                </MyText>

                                  </Col>
                                  <Row justify="space-between" align="middle">
                          <Row
                      justify="center"
                      align="middle"
                      style={{
                        background: "rgb(255, 149, 0)",
                        borderRadius: "50%",
                        width: (screens.xs || isTablet) ? 30 : 60,
                        height: (screens.xs || isTablet) ? 30 : 60,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (selectedCard?.id === item.id) {
                          if (playing) {
                            player?.pauseVideo();
                          } else {
                            player?.playVideo();
                          }
                        } else {
                          setSelectedCard(item);
                        }
                      }}
                    >
                      {selectedCard?.id === item.id && playing ? (
                        <PauseOutlined
                          style={{
                            color: "#fff",
                            fontSize: (screens.xs || isTablet) ? 20 : 44,
                            transform: "scaleX(1.3)",
                          }}
                        />
                      ) : (
                        <CaretRightOutlined
                          style={{
                            color: "#fff",
                            fontSize: (screens.xs || isTablet) ? 30 : 44,
                            marginLeft: 5,
                            transform: "scaleX(1.3)",
                          }}
                        />
                      )}
                    </Row>
                            </Row>
                                  </Row>
                                </Card>
                                  </Col>
                                  );
                                })}
            </Row>
          </Spin>
        </Card>
        </Col>   
            </Row>
            </>
        ) : supportId === 'speech' ? (
            <>
            <Row gutter={[32,32]}>
                <Col span={(screens.xs || isTablet) ? 24 : 14}>
                    <Card>
                        <Row gutter={[40,40]}>
                            <Col span={24}>
                            <Row>

                                <div
                                  ref={playerRef}
                                  style={{ width: "100%", height: (screens.xs || isTablet) ? 300 : 456, borderRadius: 20, overflow: "hidden" }}
                                />
                            </Row>
                            <MyText
                                color="rgba(31, 28, 20, 1)"
                                size={26}
                                weight={700}
                                style={{ fontFamily: 'Nunito', display: 'block', marginTop: 24 }}
                                >
                                {selectedCard?.name || "Выберите видео"}
                            </MyText>
                            </Col> 
                        </Row>
                    </Card>
                 </Col>
                 <Col
                span={(screens.xs || isTablet) ? 24 : 10}
              >
        <Card style={{borderRadius: '20px'}}>
          <Spin spinning={talesListState?.loading}>
            <Row gutter={[24, 24]}>
              {multimedia
                                .map((item) => {
                                  const videoId = new URL(item.link).searchParams.get('v');
                                  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                
                                  return (
                                    <Col
                                    key={item.id + "-game-category"}
                                    span={24}
                                    onClick={() => setSelectedCard(item)}
                                  >
                                  <Card
                                  bordered
                                  
                                  // hoverable
                                  style={{
                                    borderRadius: '24px',
                                    cursor: 'pointer',
                                    border: selectedCard?.id === item.id ? '4px solid rgb(255, 149, 0)' : "4px solid transparent",
                                  }}
                                >
                              <Row gutter={(screens.xs || isTablet) ? 12 : 16} justify="space-between" align="middle">
                                <Col
                                  span={(screens.xs || isTablet) ? 20 : 18}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: (screens.xs || isTablet) ? 12 : 24,
                                  }}
                                >
                                  <StyledImageWrapper
                                style={{
                                  height: (screens.xs || isTablet) ? 50 : 80,
                                  width: (screens.xs || isTablet) ? 50 : 80,
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  flexShrink: 0,
                                }}
                              >
                                <Image
                                  preview={false}
                                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                                  src={thumbnailUrl}
                                />
                              </StyledImageWrapper>
                              <MyText
                                  color="rgba(19, 15, 38, 1)"
                                  size={(screens.xs || isTablet) ? 15 : 24}
                                  weight={800}
                                  style={{
                                    fontFamily: "Nunito",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {item.name}
                                </MyText>

                                  </Col>
                                  <Row justify="space-between" align="middle">
                          <Row
                      justify="center"
                      align="middle"
                      style={{
                        background: "rgb(255, 149, 0)",
                        borderRadius: "50%",
                        width: (screens.xs || isTablet) ? 30 : 60,
                        height: (screens.xs || isTablet) ? 30 : 60,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (selectedCard?.id === item.id) {
                          if (playing) {
                            player?.pauseVideo();
                          } else {
                            player?.playVideo();
                          }
                        } else {
                          setSelectedCard(item);
                        }
                      }}
                    >
                      {selectedCard?.id === item.id && playing ? (
                        <PauseOutlined
                          style={{
                            color: "#fff",
                            fontSize: (screens.xs || isTablet) ? 20 : 44,
                            transform: "scaleX(1.3)",
                          }}
                        />
                      ) : (
                        <CaretRightOutlined
                          style={{
                            color: "#fff",
                            fontSize: (screens.xs || isTablet) ? 30 : 44,
                            marginLeft: 5,
                            transform: "scaleX(1.3)",
                          }}
                        />
                      )}
                    </Row>
                            </Row>
                                  </Row>
                                </Card>
                                  </Col>
                                  );
                                })}
            </Row>
          </Spin>
        </Card>
        </Col>   
            </Row>
            </>
        ) : (
            <Row gutter={[32,32]}>
                <Col span={24}>
                 <Card>
                    <MyText
                        color="rgba(31, 28, 20, 1)"
                        size={26}
                        weight={700}
                        style={{ fontFamily: 'Nunito', display: 'block' }}
                        >
                        {t("newMaterialSoon")}
                        </MyText>
                        </Card>
                 </Col>
            </Row>
        )}
      </Col>

      
    </Row>
        </Row>
  </>

  )
}